if (!customElements.get('test-results')) {
  class TestResults extends HTMLElement {
    constructor() {
      super();

      this.customSelect = this.querySelector('custom-select');
      this.previewsContainer = this.querySelector('[data-previews]');
      this.previews = this.querySelectorAll('[data-preview]');
      this.cta = this.querySelector('.test-results__cta a');
      this.breakpoint = window.matchMedia('(min-width: 750px)');
      this.onSelectChange = this.handleSelectChange.bind(this);
    }

    connectedCallback() {
      this.customSelect?.addEventListener('change', this.onSelectChange);
      this.initSlider();
    }

    disconnectedCallback() {
      this.customSelect?.removeEventListener('change', this.onSelectChange);
    }

    initSlider() {
      this.swiper = new Swiper(this.previewsContainer.firstElementChild, {
        effect: 'fade',
        speed: 600,
        slidesPerView: 1,
        allowTouchMove: false,
        watchOverflow: false,
      });
    }

    destroySlider() {
      this.swiper?.destroy(true, true);
    }

    handleSelectChange(e) {
      e.preventDefault();
      const index = e.detail.selectedIndex;

      this.swiper?.slideTo(index);

      const slides = this.querySelectorAll('.swiper-slide');
      for (const slide of slides) {
        if (+slide.dataset.preview === index) {
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      }

      const timeline = gsap.timeline({
        onComplete: () => timeline.revert(),
      });

      if (this.cta) {
        const newURL = this.cta.dataset[`url-${index}`];
        const newAriaLabel = this.cta.dataset[`aria-${index}`];
        this.cta.href = newURL;
        if (newAriaLabel) {
          this.cta.setAttribute('aria-label', newAriaLabel);
        }
      }
    }
  }

  customElements.define('test-results', TestResults);
}
